export default __webpack_public_path__ + "static/media/captur-gallery-2.c916769d.jpg";